export const sample = {
    "calendar": {
        "calendar01": "Calendar-Update",
        "calendar02": "Today",
        "calendar03": "Calendar-Create",
        "calendar04": "Calendar-View",
        "calendar05": "Title",
        "calendar06": "Effective Time",
        "calendar07": "Expire Time",
        "calendar08": "Status",
        "calendar09": "Announced Org",
        "calendar10": "Content",
        "calendar11": "Add Event",
        "calendar12": "YYYY/MM"
    },
    "barcode": {
        "barcode01": "Note",
        "barcode02": "Inputs allow English and number only because barcodes are usually composed of numbers.",
        "barcode03": "The scanner will simulate keyboard input. After scanning the barcode, it press enter automatically.",
        "barcode04": "Barcode machine test",
        "barcode05": "If you don’t have a barcode machine, you can download ",
        "barcode06": "After the installation is complete, you can scan the barcode to test with your mobile phone.",
        "barcode07": "Barcode",
        "barcode08": "Display result",
        "barcode09": " to test."
    },
    "chart": {
        "chart01": "Mon",
        "chart02": "Tue",
        "chart03": "Wed",
        "chart04": "Thu",
        "chart05": "Fri",
        "chart06": "Sat",
        "chart07": "Sun",
        "chart08": "Refer to the ResourceUsage of the Sample",
        "chart09": "Chart Demo",
    },
    "crypt": {
        "crypt01": "Encrypt / Decrypt fail, invalid key",
        "crypt02": "Input string",
        "crypt03": "Key",
        "crypt04": "default",
        "crypt05": "Output string",
        "crypt06": "Encrypt",
        "crypt07": "Decrypt"
    },
    "tour": {
        "tour01": "Welcome to Reactour, a tourist guide into your React Components",
        "tour02": "Setting Highlight Block",
        "tour03": "Setting Button Text",
        "tour04": "Show or Hide Buttons",
        "tour05": "輸入\"GSS\", 按下Enter結束引導工具",
        "tour06": "Prev",
        "tour07": "Next"
    },
    "css": {
        "css01": "Title",
        "css02": "List",
        "css03": "Button",
        "css04": "unordered list",
        "css05": "ordered list",
        "css06": "inline-item ",
        "css07": "item ",
        "css08": "Horizontal arrangement"
    },
    "eform": {
        "eform01": "eForm Field Definition",
        "eform02": "Field type",
        "eform03": "Field extype",
        "eform04": "Display parameters",
        "eform05": "Length limits"
    },
    "excel": {
        "excel01": " Example File",
        "excel02": "Template",
        "excel03": "How to use",
        "excel04": "Export of production Excel sets",
        "excel05": "For detailed settings, refer to the program download example of AsposeExcelSetController.",
        "excel06": "Template style",
        "excel07": "Vertical dynamical data generation example (Auto CreateRow)",
        "excel08": "Vertical dynamical data generation example (Default Row range)",
        "excel09": "Single field replacement",
        "excel10": "The above styles can refer to the Excel sample set file",
        "excel11": "Support format",
        "excel12": "Excel To 'Xlsx、Xls、Ods、Pdf、Html'",
        "excel13": "Export format",
    },
    "word": {
        "word01": " Instructions download",
        "word02": "Export Word set",
        "word03": "How to use",
        "word04": "Export of production Word sets",
        "word05": "For detailed parameter settings, please refer to the AsposeWordSet instructions for download, and refer to the ExportReportController program download example",
        "word06": "Support format",
        "word07": "Word To 'Doc、Docx、Odt、Pdf'",
        "word08": "Export format",
        "word09": "Export Data Example",
        "word10": "Parameter Type Id",
        "word11": "Parameter Type",
        "word12": "Memo"
    },
    "resourceUsage": {
        "resourceUsage01": "Resource Usage"
    },
    "grid": {
        "grid01": " Demo",
        "grid02": "Function Id",
        "grid03": "Function Name"
    }
}